import { Link } from "@fluentui/react/lib/Link";
import { Text } from "@fluentui/react/lib/Text";
import { TooltipHost, TooltipOverflowMode } from "@fluentui/react/lib/Tooltip";

import { IFieldMetadata } from "Model/Configuration/IFieldMetadata";
import { EntityType } from "Model/EntityType";
import { IItem } from "Model/Storage/IItem";
import { getFormattedValue } from "Utils/Field";
import { isImageListField, isStringListField, isUrlListField } from "Utils/Metadata";
import { isNullish } from "Utils/Null";
import { truncateUrl } from "Utils/String";
import { Translator } from "Utils/Translator";
import { WithConfiguration } from "../Configuration";
import { WithTranslator } from "../Translator";
import { IValueWithTooltipProps } from "./IValueWithTooltipProps";
import { useValueWithTooltipStyles } from "./UseValueWithTooltipStyles";

export const ValueWithTooltip = WithConfiguration(
  WithTranslator((props: IValueWithTooltipProps): JSX.Element => {
    const {
      item, fieldName, entityType = EntityType.Project, translator, config, styleSet
    } = props;
    const styles = useValueWithTooltipStyles(styleSet);
    const fieldMetadata = config.getMetadata(fieldName, entityType);
    return <div className={styles.root}>{getFormattedEntryValue(item, fieldMetadata, translator, styles, `-`)}</div>;
  })
);

function getFormattedEntryValue(
  item: IItem,
  fieldMetadata: IFieldMetadata,
  translator: Translator,
  // TODO: Fix eslint-disable
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  styles: any,
  placeholder = `-`
): JSX.Element {
  const value = item?.[fieldMetadata.fieldName];
  if (isNullish(value)) {
    return <Text>{placeholder}</Text>;
  }

  if (isStringListField(fieldMetadata)) {
    return (
      <ul className={styles.list}>
        {(value as string[]).map((v, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={index}>
            <Text block nowrap>
              <TooltipHost closeDelay={1000} content={v ?? `-`} overflowMode={TooltipOverflowMode.Parent}>
                {v}
              </TooltipHost>
            </Text>
          </li>
        ))}
      </ul>
    );
  }

  if (isImageListField(fieldMetadata) || isUrlListField(fieldMetadata)) {
    return (
      <ul className={styles.list}>
        {(value as string[]).map((v, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={index}>
            <Link href={v} target="_blank">
              <Text block nowrap>
                <TooltipHost closeDelay={1000} content={v ?? `-`} overflowMode={TooltipOverflowMode.Parent}>
                  {truncateUrl(v)}
                </TooltipHost>
              </Text>
            </Link>
          </li>
        ))}
      </ul>
    );
  }

  return <Text>{getFormattedValue(item, fieldMetadata, translator, placeholder)}</Text>;
}
